import {ServiceBase} from "../ServiceBase";
import {IPixiAppService, IPixiAppCreateOptions} from "./pixi-app.service.interface";
import {PixiAsset} from "./pixi-assets-manager/asset/pixi-asset";
import {PixiLibWrapper} from "./pixi-lib-wrapper/pixi-lib-wrapper";
import {PixiAnimation} from "./pixi-animation";
import {CSSProperties} from "react";
import {IAnimationRenderer} from "./pixi-animation.interface";
import {PixiSpineAnimation} from "./pixi-spine-animation";
import {PixiSpineResource} from "./resources/pixi-spine-resource";

/**
 * This service will manage pixi applications.
 *
 */
export class PixiAppService extends ServiceBase implements IPixiAppService {

    public createPixiAnimation<T extends string = string>(
        pixiAppCreateOptions: IPixiAppCreateOptions,
        assetsUrls: Record<T, string>,
        renderer: IAnimationRenderer<T, PixiAsset>,
        canvasCss?: CSSProperties,
        debugMode?: boolean
    ): PixiAnimation {
        const _pixiLibWrapperPromise = PixiLibWrapper.getInstancePromise(this.services);
        return new PixiAnimation(
            _pixiLibWrapperPromise,
            pixiAppCreateOptions,
            assetsUrls,
            renderer,
            canvasCss,
            debugMode
        );
    }

    
    public createPixiSpineAnimation<T extends string = string>(
        pixiAppCreateOptions: IPixiAppCreateOptions,
        assetsUrls: Record<T, string>,
        renderer: IAnimationRenderer<T, PixiSpineResource>,
        canvasCss?: CSSProperties
    ): PixiSpineAnimation {
        const _pixiLibWrapperPromise = PixiLibWrapper.getInstancePromise(this.services);
        return new PixiSpineAnimation(
            _pixiLibWrapperPromise,
            pixiAppCreateOptions,
            assetsUrls,
            renderer,
            canvasCss
        );
    }
}
